import {nanoid} from "nanoid";
import {FieldTimeOutlined, CompassOutlined, DashboardOutlined, FireOutlined, DollarOutlined} from '@ant-design/icons';

const stats = [
    {
        id: nanoid(),
        icon: <FireOutlined />,
        title: "Missions",
        name: "totalMissions",
    },
    {
        id: nanoid(),
        icon: <DollarOutlined />,
        title: "Total value",
        name: "totalValue",
    },
    {
        id: nanoid(),
        icon: <DollarOutlined />,
        title: "Avg value",
        name: "avgMissionValue",
    },
    {
        id: nanoid(),
        icon: <FieldTimeOutlined />,
        title: "Total Time",
        name: "totalTime"
    },
    {
        id: nanoid(),
        icon: <DashboardOutlined />,
        title: "Avg Time",
        name: "avgTime"
    },
    {
        id: nanoid(),
        icon: <CompassOutlined />,
        title: "CO2 Tons Saved",
        name: "totalCarbonSaved"
    },
];

export const getTotalMissions = (missions) => missions?.length;

export const getTotalTime = (missions) => {
    if(missions === undefined) {
        return missions
    }
    return missions.reduce((acum, {time_hours, time_minutes}) => acum + time_hours + time_minutes / 60 , 0);
}

export const getTotalValue = (missions) => {
    if(missions === undefined) {
        return missions
    }
    return missions.reduce((acum, {expected_hours}) => acum + expected_hours * 50 + 50, 0);
}

export const getTotalCarbonSaved = (missions) => {
    if(missions === undefined) {
        return missions
    }
    const result = missions.reduce((acum, {client_distance})=> acum + Number(client_distance) * 0.05994, 0);
    return Math.round(result)
}

export const searchFunction = (data, value) => {
    const search = value.toLowerCase();
    const hits = data.hits.filter(({name, email, phone}) => {
        return name.toLowerCase().includes(search) || email.toLowerCase().includes(search) || phone.toLowerCase().includes(search)
    })
    return {...data, hits}
}

export const createAddressOptions = ((data = []) => {
    console.log(data)
    const unique = new Set(data);
    return [...unique].map(value => ({value, text: value, id: nanoid()}));
});

export const getResultData = (data, search, countries = [], cities = []) => {
    const searchData = search ? searchFunction(data, search) : data;
    const countryHits = countries.length ? searchData.hits.filter(({address_country}) => countries.includes(address_country)) : searchData.hits;
    const cityHits = cities.length ? countryHits.filter(({address_city}) => cities.includes(address_city)) : countryHits;
    return {...searchData, hits: cityHits};
}

export default stats;
